import { useInsightStore } from '../stores/insightStore'

import { registerSessionReset } from '@/features/auth'

/** Clear workspace-scoped insight caches on logout so no tenant data survives the session. */
export function registerInsightSessionReset(): () => void {
  const store = useInsightStore()
  return registerSessionReset(() => store.resetState())
}
